import { useEffect } from 'react'
import callingVoiceIntegrity from 'shared/assets/images/compliance/callingVoiceIntegrity.png'
import { getCDNAssetURL } from 'shared/lib'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { useCallingStepsContext } from 'pages/settings/pages/compliance/pages/calling/context/callingStepsContext'
import { PageErrorAlert } from 'pages/settings/pages/compliance/ui/PageErrorAlert/PageErrorAlert'
import styles from './styles.module.scss'

export const EnableVoiceIntegrity = () => {
  const {
    stepsStore: { setTotalSteps },
    voiceIntegrityStore: { errorMessage, movetoVoiceIntegritySecondStep },
  } = useCallingStepsContext()

  useEffect(() => {
    setTotalSteps(2)
  }, [])

  return (
    <div>
      <PageDescription>Remediate “Spam Likely” labels on your calls</PageDescription>

      <PageErrorAlert errorMessage={errorMessage} marginTop={20} />

      <img
        src={getCDNAssetURL(callingVoiceIntegrity)}
        alt={'callingVoiceIntegrity_image'}
        className={styles.image}
      />

      <NextButton text='Next' onClick={movetoVoiceIntegritySecondStep} />
    </div>
  )
}
